import { render, staticRenderFns } from "./note-dialog.vue?vue&type=template&id=a7673a72&"
import script from "./note-dialog.vue?vue&type=script&lang=js&"
export * from "./note-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports